import type { EChartsCoreOption } from 'echarts/core';

import { CHART_HEADINGS } from '../constants';
import { ChartBlock } from './MonitoringChart';

type MonitoringProductionSectionProps = {
  apiCallsOption: EChartsCoreOption | null;
  riskScoresOption: EChartsCoreOption | null;
  costOption: EChartsCoreOption | null;
  hourlyLoading: boolean;
  riskLoading: boolean;
  costLoading: boolean;
  costChartHeight: number;
};

const MonitoringProductionSection = ({
  apiCallsOption,
  riskScoresOption,
  costOption,
  hourlyLoading,
  riskLoading,
  costLoading,
  costChartHeight
}: MonitoringProductionSectionProps) => (
  <section className="realtime-monitoring-tab__section realtime-monitoring-tab__section--monitor">
    <h2 className="realtime-monitoring-tab__section-title">Production monitoring</h2>
    <div className="realtime-monitoring-tab__chart-grid realtime-monitoring-tab__chart-grid--stacked">
      <ChartBlock
        title={CHART_HEADINGS.apiCallsByHour}
        option={apiCallsOption}
        loading={hourlyLoading}
        fullWidth
        modern
      />
      <ChartBlock
        title={CHART_HEADINGS.riskScoresByHour}
        option={riskScoresOption}
        loading={riskLoading}
        fullWidth
        modern
        panelVariant="risk"
      />
    </div>
    <ChartBlock
      title={CHART_HEADINGS.costByProject}
      option={costOption}
      loading={costLoading}
      fullWidth
      modern
      chartHeight={costChartHeight}
    />
  </section>
);

export default MonitoringProductionSection;
